import {useState} from 'react';
import Login from '../../components/login/Login';
import PrivacyPolicy from '../../components/privacyPolicy/PrivacyPolicy';
import './style.css';

const LoginPage= () => {
  const [showModal, setShowModal] = useState<boolean>(false);

  return (
    <div className='mainBackgroundImageDiv'>
      <div className='innerCard'>
        <div className='ImageCard'></div>
        <div className='loginCard'>
          <Login setShowModal={setShowModal}/>
        </div>
      </div>
     { showModal &&<PrivacyPolicy setShowModal={setShowModal}/>}
    </div>
  );
};

export default LoginPage;
